import React from 'react';
import Brokerage from "./Brokerage"
import Hero from "./Hero"
import OpenAccount from "../OpenAccount"


function Pricing() {
    return ( 
        <>
        <Hero/>
        <OpenAccount/>
        <Brokerage/>
        
        </>
     );
}

export default Pricing;